import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { memo, useState } from 'react';
import { noop } from 'lodash';
import { createContext, useContextSelector } from 'use-context-selector';

/**
 * Legacy Shares Component ~
 * This context is made for managing selected Shares Panel (i.e. All Shares,
 * Review Links, Presentations) in conjunction with SelectionContext.
 */

export type PanelId = 'all-shares' | 'review-links' | 'presentations';

type SelectedSharePanelIdContextValues = {
  selectedSharePanelId: PanelId | null;
  setSelectedSharePanelId: Dispatch<SetStateAction<PanelId | null>>;
};

export const SelectedSharePanelIdContext =
  createContext<SelectedSharePanelIdContextValues>({
    selectedSharePanelId: null,
    setSelectedSharePanelId: noop,
  });

export const SelectedSharePanelIdContextProvider = memo(
  ({ children }: PropsWithChildren<Record<never, any>>) => {
    const [selectedSharePanelId, setSelectedSharePanelId] =
      useState<PanelId | null>('all-shares');

    const context = {
      selectedSharePanelId,
      setSelectedSharePanelId,
    };

    return (
      <SelectedSharePanelIdContext.Provider value={context}>
        {children}
      </SelectedSharePanelIdContext.Provider>
    );
  }
);

export const useGetSelectedSharePanelIdContext = () => {
  const activeSharePanelId = useContextSelector(
    SelectedSharePanelIdContext,
    (context) => context.selectedSharePanelId
  );

  return activeSharePanelId;
};

export const useSetSelectedSharePanelIdContext = () => {
  const setActiveSharePanelId = useContextSelector(
    SelectedSharePanelIdContext,
    (context) => context.setSelectedSharePanelId
  );

  return setActiveSharePanelId;
};
